/**
 * Toast wrappers — keep `friendlyError` translation centralized so every
 * mutation error surfaces in Chinese. Use these instead of importing
 * `toast` from sonner directly so future changes (e.g. swap the lib) are
 * localized to this file.
 */

import { toast } from 'sonner';

import { ApiError } from './api';
import { friendlyError } from './friendlyError';

export function toastSuccess(message: string, opts?: { description?: string }) {
  toast.success(message, opts);
}

export function toastInfo(message: string, opts?: { description?: string }) {
  toast.info(message, opts);
}

export function toastError(err: unknown, fallback = '操作失败') {
  const text =
    err instanceof ApiError
      ? friendlyError(err)
      : err instanceof Error
        ? err.message
        : fallback;
  toast.error(text);
}
